import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../context/tenant-context';
import { v2Component } from '../../index';
import { CustomerContextProvider } from '../../context/customer-context';
import { LicenseScanWrapper } from './license-scan-wrapper';
import { LicenseDetailsWrapper } from './license-details-wrapper';

export function initLicenseScan() {
  const elements = document.getElementsByName('license-scan');
  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');

      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;

      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <CustomerContextProvider>
              <LicenseScanWrapper {...props} />
            </CustomerContextProvider>
          </TenantContext.Provider>,
        ),
      );
    }
  });
}

export function initLicenseDetails() {
  const elements = document.getElementsByName('license-details');
  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');

      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;

      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <CustomerContextProvider>
              <LicenseDetailsWrapper {...props} />
            </CustomerContextProvider>
          </TenantContext.Provider>,
        ),
      );
    }
  });
}
